import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserOutputCashService from 'mt-react-common/modules/authUserOutputCash/services/UserOutputCashService';

import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';

class UserOutputCashHistoryTableItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingResendCustomerApproveToken: false
    };
  }

  resendCustomerApproveToken = id => {
    this.setState({ isLoadingResendCustomerApproveToken: true });
    UserOutputCashService.resendCustomerApproveToken(id).then(result => {
      if (result.status === 200) {
        this.props.addClientNotice({
          type: 'success',
          message: result.data.message
        });
      } else if ([403].includes(result.status)) {
        this.props.addClientNotice({
          type: 'danger',
          message: result.data.message
        });
      }
      this.setState({ isLoadingResendCustomerApproveToken: false });
      console.log(result);
    });
  };

  render() {
    return (
      <React.Fragment>
        <a
          data-toggle="tooltip"
          data-container="body"
          data-placement="top"
          href=""
          title={'Повторная отправка информации для подтверждения выплаты'}
          onClick={e => {
            e.preventDefault();
            if (!this.state.isLoadingResendCustomerApproveToken) {
              this.resendCustomerApproveToken(this.props.id);
            }
          }}
        >
          <i className="fa fa-envelope" />
        </a>
      </React.Fragment>
    );
  }
}

UserOutputCashHistoryTableItem.propTypes = {
  id: PropTypes.number.isRequired,
  addClientNotice: PropTypes.func.isRequired
};

const mapStateToProps = () => {};

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserOutputCashHistoryTableItem);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashHistoryTable/_actions/CustomerApproveActions.js